import { render, staticRenderFns } from "./order_logs.vue?vue&type=template&id=164e8d3e&scoped=true&"
import script from "./order_logs.vue?vue&type=script&lang=js&"
export * from "./order_logs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164e8d3e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('164e8d3e')) {
      api.createRecord('164e8d3e', component.options)
    } else {
      api.reload('164e8d3e', component.options)
    }
    module.hot.accept("./order_logs.vue?vue&type=template&id=164e8d3e&scoped=true&", function () {
      api.rerender('164e8d3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/orders/order/order_logs/order_logs.vue"
export default component.exports